import { useState, useEffect } from "react";
import { API, axios } from "@/api";
import { Clock, History } from "lucide-react";
import { TIERS } from "./TieredPunchCard";

export default function CardArchive({ businessId, businessName, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/punchcard/history/${businessId}`);
        setHistory(res.data?.tier_history || []);
      } catch { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, [businessId]);

  return (
    <div className="bg-white rounded-xl border border-slate-100 p-4" data-testid="card-archive">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <History className="w-4 h-4 text-[#F59E0B]" />
          <h3 className="text-sm font-bold text-slate-800">
            Your loyalty history at {businessName || "this truck"}
          </h3>
        </div>
        {onClose && (
          <button onClick={onClose} className="text-xs text-slate-400 hover:text-slate-600">Close</button>
        )}
      </div>

      {loading ? (
        <div className="py-6 text-center text-xs text-slate-400">Loading...</div>
      ) : history.length === 0 ? (
        <div className="py-8 text-center" data-testid="archive-empty">
          <p className="text-sm text-slate-400">First completed card will appear here.</p>
        </div>
      ) : (
        <div className="space-y-3 max-h-80 overflow-y-auto" data-testid="archive-list">
          {history.map((entry, i) => {
            const t = TIERS[entry.tier] || TIERS[1];
            const date = entry.completed_at ? new Date(entry.completed_at) : null;
            return (
              <div key={i} className="flex items-start gap-3 bg-slate-50 rounded-lg p-3" data-testid={`archive-entry-${i}`}>
                {/* SVG Thumbnail with REDEEMED stamp */}
                <div className="relative shrink-0" style={{ width: "60%", maxWidth: 180 }}>
                  {entry.card_thumbnail_data ? (
                    <div dangerouslySetInnerHTML={{ __html: entry.card_thumbnail_data }} className="w-full" />
                  ) : (
                    <div className="w-full aspect-[1.7/1] rounded-lg" style={{ background: t.bg, border: `2px solid ${t.color}` }} />
                  )}
                  {/* REDEEMED stamp overlay */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span
                      className="text-red-500 font-black text-xs border-2 border-red-500 px-2 py-0.5 rounded rotate-[-12deg] opacity-70 bg-white/80"
                      data-testid="redeemed-stamp"
                    >
                      REDEEMED
                    </span>
                  </div>
                </div>

                <div className="flex-1 min-w-0 pt-1">
                  <span
                    className="text-[10px] font-bold px-2 py-0.5 rounded-full"
                    style={{ color: t.accent, background: `${t.color}20` }}
                  >
                    {t.name}
                  </span>
                  {entry.reward_redeemed && (
                    <p className="text-xs text-slate-600 mt-1 truncate">{entry.reward_redeemed}</p>
                  )}
                  {date && (
                    <p className="text-[10px] text-slate-400 mt-0.5 flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      {date.toLocaleDateString()} {date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
